import { fetchConfig } from "../utilities/utils"
import cartService from "../sections/main-cart"

const addToCartFromCard = () => {
  const addProductForm = document.querySelectorAll('form[data-type="add-to-cart-form"]')
  const mainCart = document.getElementById("main-cart")
  const miniCart = document.getElementById("mini-cart")
  const body = document.querySelector("body")

  if (addProductForm.length)
    addProductForm.forEach((element) =>
      element.addEventListener("submit", (e) => {
        // prevent default shopify add to cart functionality
        e.preventDefault()
        e.stopPropagation()

        if (e.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)')) {
          e.target.querySelector(
            'button[type="submit"] > span:not(.cart-icon):not(:empty)',
          ).textContent = `${cartStrings.addingToCart}`
        }

        const submitButton = e.target.querySelector('button[type="submit"]')
        const buttonCartIcon = submitButton.querySelector("span.cart-icon")
        const buttonLoadingIcon = submitButton.querySelector("svg.loading-icon")

        body.classList.remove("added-to-cart")
        submitButton.classList.add("added")
        buttonCartIcon.style.display = "none"
        buttonLoadingIcon.style.display = "block"

        const config = fetchConfig("javascript")
        config.headers["X-Requested-With"] = "XMLHttpRequest"
        delete config.headers["Content-Type"]
        const formData = new FormData(element)
        formData.append("sections", "main-cart")
        config.body = formData

        fetch(`${routes.cartAdd}`, config)
          .then((response) => {
            return response.json()
          })
          .then(async (response) => {
            if (response.status) {
              cartService.updateMiniCart(true)

              buttonCartIcon.style.display = "inline-flex"
              buttonLoadingIcon.style.display = "none"
              if (
                e.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)')
              ) {
                e.target.querySelector(
                  'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                ).textContent = `${cartStrings.addToCart}`
              }
              if (typeof response.description === "object") {
                return Object.entries(response.description).forEach(([key, value]) => {
                  const message = `${value.join(", ")}`
                  e.target.querySelector(".main-product__error").innerHTML =
                    '<span class="icon loaded">error</span><p>' + message + "</p>"
                })
              } else {
                e.target.querySelector(".main-product__error").innerHTML =
                  '<span class="icon loaded">error</span><p>' + response.description + "</p>"
              }
            } else {
              if (cartStrings.uxCart === "cart") {
                window.location.href = window.routes.cart
                return
              }

              e.target.querySelector(".main-product__error").innerHTML = ""
              if (mainCart) mainCart.classList.add("added")

              if (!response.sections || response.sections["main-cart"] === null) {
                // Try fetching section directly
                const sectionUrl = `${window.location.pathname}?section_id=main-cart`

                fetch(sectionUrl)
                  .then((response) => response.text())
                  .then((sectionHtml) => {
                    // Parse and render the cart items
                    cartService.renderItems(
                      new DOMParser().parseFromString(sectionHtml, "text/html"),
                    )
                  })
              } else {
                cartService.renderItems(
                  new DOMParser().parseFromString(response.sections["main-cart"], "text/html"),
                )
              }

              // Handle post-add behaviors
              if (cartStrings.uxCart === "mini-cart" && miniCart) {
                miniCart.open()
              }

              if (
                e.target.querySelector('button[type="submit"] > span:not(.cart-icon):not(:empty)')
              ) {
                e.target.querySelector(
                  'button[type="submit"] > span:not(.cart-icon):not(:empty)',
                ).textContent = `${cartStrings.addedToCart}`
              }
              submitButton.classList.remove("added")
              submitButton.classList.add("successful")
              buttonCartIcon.style.display = "flex"
              buttonLoadingIcon.style.display = "none"

              body.classList.add("added-to-cart")
            }
          })
          .catch((error) => {
            console.error("Error:", error)
          })
      }),
    )
}

export { addToCartFromCard }
